/**
 * @deprecated Este componente está depreciado.
 * A nova versão com layout atualizado é: `new-query-details.jsx` (NewQueryDetails).
 */
import React from 'react';

import Skel from '../skel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import * as fmt from '../../utils/fmt';

import styles from './styles.css';

const statusColors = {
  3: 'green',
  4: 'red',
  5: 'red'
};

export default function QueryDetails({ query = {} }) {
  const loading = !(query && query.id);

  return <>
    <Typography
      className={styles.mdSectionTitle}
      variant="subtitle1"
      component="h5"
      color="primary"
    >
      Consulta
    </Typography>

    <Grid spacing={24} container>
      <Grid item md={1} sm={2}>
        <div>
          <Typography variant="subtitle2">
            Código
          </Typography>

          <Skel loading={loading}>{query.id}</Skel>
        </div>
      </Grid>

      <Grid item md={1} sm={2}>
        <div>
          <Typography variant="subtitle2">
            Tipo
          </Typography>

          <Skel loading={loading}>{query.type && query.type.description}</Skel>
        </div>
      </Grid>

      <Grid item md={2} sm={3}>
        <div>
          <Typography variant="subtitle2">
            Data Envio
          </Typography>

          <Skel loading={loading}>{fmt.isoDate(query.sentDate)}</Skel>
        </div>
      </Grid>

      <Grid item md={2} sm={3}>
        <div>
          <Typography variant="subtitle2">
            Data de Recebimento
          </Typography>

          <Skel loading={loading}>{fmt.isoDate(query.receivingDate)}</Skel>
        </div>
      </Grid>

      {
        query.limitDate &&
          <Grid item md={2} sm={3}>
            <div>
              <Typography variant="subtitle2">
                Data Vencimento
              </Typography>

              <Skel loading={loading}>{fmt.isoDate(query.limitDate)}</Skel>
            </div>
          </Grid>
      }

      {
        query.daysUntilDue &&
          <Grid item md={2} sm={3}>
            <div>
              <Typography variant="subtitle2">
                Dias Vencimento
              </Typography>

              <Skel loading={loading}>{query.daysUntilDue}</Skel>
            </div>
          </Grid>
      }

      <Grid item md={2} sm={3}>
        <div>
          <Typography variant="subtitle2">
            Situação
          </Typography>

          <Skel loading={loading}>
            <span style={{ color: query.status ? statusColors[query.status.id] : undefined }}>
              {query.status && query.status.description}
            </span>
          </Skel>
        </div>
      </Grid>

      <Grid item md={2} sm={3}>
        <div>
          <Typography variant="subtitle2">
            Usuário
          </Typography>

          <Skel loading={loading}>{query.user && query.user.login}</Skel>
        </div>
      </Grid>

      <Grid item sm={12}>
        <div className={styles.gridCell}>
          <Typography color="primary" variant="subtitle1">
            Comentário
          </Typography>

          <Skel loading={loading}>
            {query.description}
          </Skel>
        </div>
      </Grid>

      <Grid item sm={12}>
        <div className={styles.gridCell}>
          <Typography color="primary" variant="subtitle1">
            Comentário Certificado
          </Typography>

          <Skel loading={loading}>
            <Typography style={{ wordBreak: 'break-all' }}>
              {query.observationCertificate || '-'}
            </Typography>
          </Skel>
        </div>
      </Grid>
    </Grid>
  </>;
}
